<div class="col-xs-12">
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="cadastroPropriedade.goToIndex()">Voltar</div>
    <div class="btn btn-primary btn-sm btn-action" ng-click="cadastroPropriedade.edit()" ng-if="permissions.propriedades.canManage">
      Editar <i class="glyphicon glyphicon-pencil"></i>
    </div>
  </div>
</div>
